export const environment = {
  production: process.env["ISPRODUCTION"],
  clientId: process.env["AUTH_CLIENT_CLIENTID"],
  authority: "https://login.microsoftonline.com/329e91b0-e21f-48fb-a071-456717ecc28e",
  validateAuthority: true,
  redirectUri: process.env["AUTH_CLIENT_REDIRECTURI"],
  postLogoutRedirectUri: process.env["AUTH_CLIENT_POSTLOGOUTREDIRECTURI"],
  navigateToLoginRequestUrl: true,
  foundationPlatformApi_client_resourceUri: process.env["FOUNDATIONPLATFORMAPI_CLIENT_RESOURCEURI"],
  foundationPlatformApi_client_resourceScope: process.env["FOUNDATIONPLATFORMAPI_CLIENT_RESOURCESCOPE"],
  platformAdminApi_client_resourceUri: process.env["PLATFORMADMINAPI_CLIENT_RESOURCEURI"],
  platformAdminApi_client_resourceScope: process.env["PLATFORMADMINAPI_CLIENT_RESOURCESCOPE"],
  groups_client_PlatformAdminGroupId: process.env["GROUPS_CLIENT_PLATFORMADMINGROUPID"],
  groups_client_TagAdminGroupId: process.env["GROUPS_CLIENT_TAGADMINGROUPID"],
  groups_client_FoundationUserGroupId: process.env["GROUPS_CLIENT_FOUNDATIONUSERGROUPID"],
  graphApi_client_resourceUri: "https://graph.microsoft.com/v1.0/me/memberOf",
  graphApi_client_resourceScope: "User.Read",
  cache_client: {
    cacheLocation: "localStorage"
  },
  ReleaseDetails: {
    Version: "1.0.0",
    DateOfBuild: "NA",
    BuildNumber: "NA"
  },
  subscription: process.env["SUBSCRIPTION"],
  environment: process.env["ENVIRONMENT"],
  moveTagMasterMsg: "Move to Pre-Production",
  platformHomeUrl: process.env["PLATFORMHOMEURL"],
  platformHubUrl: process.env["PLATFORMHUBURL"],
  appInsightKey: process.env["APPINSIGHTKEY"],
  platformDocumentation: process.env["PLATFORMDOCUMENTATION"]
};